export type PortalEnvironment = 'development' | 'production'

export const timeZoneOffset = new Date().getTimezoneOffset()
export const PowerSiteLanguage = false
export const DEFAULT_LANGUAGE = 'en'
export const DEFAULT_CULTURE = 'en-US'

export const LISTING_SLUGS = {
  ar: ['qaemh'],
  cs: ['seznam'],
  da: ['bolig'],
  de: ['objekt'],
  el: ['lista'],
  en: ['listing'],
  es: ['vivienda'],
  fr: ['annonce'],
  it: ['immobili'],
  ja: ['リスト'],
  nl: ['advertentie'],
  pl: ['oferta'],
  pt: ['anuncio'],
  ro: ['imobiliare'],
  ru: ['объект'],
  sk: ['nepremicnina'],
  sv: ['bostad'],
  tr: ['emlak'],
  zh: ['房源'],
  hr: ['popis'],
}

export const PROJECT_SLUGS = {
  ar: ['مشروع'],
  fr: ['programme-neuf'],
  en: ['project'],
  zh: ['项目'],
  de: ['projekt'],
  it: ['progetto'],
  es: ['proyecto'],
  ru: ['проект'],
  sk: ['zastavba'],
  sv: ['nyproduktion'],
  el: ['έργο'],
  hr: ['razvoj'],
  pt: ['projeto'],
  da: ['byggeri'],
  nl: ['nieuwbouw'],
  ro: ['proiect'],
  pl: ['inwestycja'],
  cs: ['stavba'],
  ja: ['プロジェクト'],
  tr: ['proje'],
}

export const CULTURE_TO_DOMAINS: Record<
  PortalEnvironment,
  Record<string, string>
> = {
  development: {
    es: 'release.properstar.com',
    'ar-AE': 'release.properstar.ae',
    en: 'release.properstar.com',
    'de-AT': 'release.properstar.at',
    'en-AU': 'release.properstar.com.au',
    'nl-BE': 'release.properstar.be',
    'fr-BE': 'release.properstar.be',
    'de-BE': 'release.properstar.be',
    'en-CA': 'release.properstar.ca',
    'fr-CA': 'release.properstar.ca',
    'fr-CH': 'release.properstar.ch',
    'de-CH': 'release.properstar.ch',
    'it-CH': 'release.properstar.ch',
    'en-US': 'release.properstar.com',
    'ar-BH': 'release.properstar.com',
    'ar-JO': 'release.properstar.com',
    'ar-KW': 'release.properstar.com',
    'ar-OM': 'release.properstar.com',
    'ar-SA': 'release.properstar.com',
    'en-BW': 'release.properstar.com',
    'fr-CF': 'release.properstar.com',
    'fr-CI': 'release.properstar.com',
    'fr-CM': 'release.properstar.com',
    'fr-GN': 'release.properstar.com',
    'es-GQ': 'release.properstar.com',
    'pt-GW': 'release.properstar.com',
    hr: 'release.properstar.com',
    fr: 'release.properstar.com',
    'ro-MD': 'release.properstar.com',
    'en-MG': 'release.properstar.com',
    'fr-ML': 'release.properstar.com',
    'en-MT': 'release.properstar.com',
    pt: 'release.properstar.com',
    'fr-NE': 'release.properstar.com',
    sk: 'release.properstar.com',
    'fr-SN': 'release.properstar.com',
    'es-AR': 'release.properstar.com',
    'en-BB': 'release.properstar.com',
    'en-BM': 'release.properstar.com',
    'es-BO': 'release.properstar.com',
    'en-BZ': 'release.properstar.com',
    'es-CL': 'release.properstar.com',
    'es-CO': 'release.properstar.com',
    'es-CR': 'release.properstar.com',
    'es-DO': 'release.properstar.com',
    'es-EC': 'release.properstar.com',
    'es-GT': 'release.properstar.com',
    'en-GY': 'release.properstar.com',
    'es-HN': 'release.properstar.com',
    'en-JM': 'release.properstar.com',
    'es-NI': 'release.properstar.com',
    'es-PA': 'release.properstar.com',
    'es-PE': 'release.properstar.com',
    'es-PR': 'release.properstar.com',
    'es-PY': 'release.properstar.com',
    nl: 'release.properstar.nl',
    'es-SV': 'release.properstar.com',
    'es-UY': 'release.properstar.com',
    'es-VE': 'release.properstar.com',
    'pt-BR': 'release.properstar.com.br',
    'en-NZ': 'release.properstar.co.nz',
    'en-GB': 'release.properstar.co.uk',
    cs: 'release.properstar.cz',
    'de-DE': 'release.properstar.de',
    da: 'release.properstar.dk',
    'es-ES': 'release.properstar.es',
    'fr-FR': 'release.properstar.fr',
    el: 'release.properstar.gr',
    'en-HK': 'release.properstar.hk',
    'en-IN': 'release.properstar.in',
    it: 'release.properstar.it',
    ja: 'release.properstar.jp',
    'de-LI': 'release.properstar.li',
    'fr-LU': 'release.properstar.lu',
    'de-LU': 'release.properstar.lu',
    'en-MU': 'release.properstar.mu',
    'es-MX': 'release.properstar.mx',
    'en-PH': 'release.properstar.ph',
    pl: 'release.properstar.pl',
    'pt-PT': 'release.properstar.pt',
    'ar-QA': 'release.properstar.qa',
    ro: 'release.properstar.ro',
    ru: 'release.properstar.ru',
    sv: 'release.properstar.se',
    'en-SG': 'release.properstar.sg',
    zh: 'release.sodichan.com',
    'zh-Hans-HK': 'release.sodichan.com',
    'zh-Hans-MO': 'release.sodichan.com',
    tr: 'release.properstar.com.tr',
    'en-ZA': 'release.properstar.co.za',
  },
  production: {
    es: 'www.properstar.com',
    'ar-AE': 'www.properstar.ae',
    en: 'www.properstar.com',
    'de-AT': 'www.properstar.at',
    'en-AU': 'www.properstar.com.au',
    'nl-BE': 'www.properstar.be',
    'fr-BE': 'www.properstar.be',
    'de-BE': 'www.properstar.be',
    'en-CA': 'www.properstar.ca',
    'fr-CA': 'www.properstar.ca',
    'fr-CH': 'www.properstar.ch',
    'de-CH': 'www.properstar.ch',
    'it-CH': 'www.properstar.ch',
    'en-US': 'www.properstar.com',
    'ar-BH': 'www.properstar.com',
    'ar-JO': 'www.properstar.com',
    'ar-KW': 'www.properstar.com',
    'ar-OM': 'www.properstar.com',
    'ar-SA': 'www.properstar.com',
    'en-BW': 'www.properstar.com',
    'fr-CF': 'www.properstar.com',
    'fr-CI': 'www.properstar.com',
    'fr-CM': 'www.properstar.com',
    'fr-GN': 'www.properstar.com',
    'es-GQ': 'www.properstar.com',
    'pt-GW': 'www.properstar.com',
    hr: 'www.properstar.com',
    fr: 'www.properstar.com',
    'ro-MD': 'www.properstar.com',
    'en-MG': 'www.properstar.com',
    'fr-ML': 'www.properstar.com',
    'en-MT': 'www.properstar.com',
    pt: 'www.properstar.com',
    'fr-NE': 'www.properstar.com',
    sk: 'www.properstar.com',
    'fr-SN': 'www.properstar.com',
    'es-AR': 'www.properstar.com',
    'en-BB': 'www.properstar.com',
    'en-BM': 'www.properstar.com',
    'es-BO': 'www.properstar.com',
    'en-BZ': 'www.properstar.com',
    'es-CL': 'www.properstar.com',
    'es-CO': 'www.properstar.com',
    'es-CR': 'www.properstar.com',
    'es-DO': 'www.properstar.com',
    'es-EC': 'www.properstar.com',
    'es-GT': 'www.properstar.com',
    'en-GY': 'www.properstar.com',
    'es-HN': 'www.properstar.com',
    'en-JM': 'www.properstar.com',
    'es-NI': 'www.properstar.com',
    'es-PA': 'www.properstar.com',
    'es-PE': 'www.properstar.com',
    'es-PR': 'www.properstar.com',
    'es-PY': 'www.properstar.com',
    nl: 'www.properstar.com',
    'es-SV': 'www.properstar.com',
    'es-UY': 'www.properstar.com',
    'es-VE': 'www.properstar.com',
    'pt-BR': 'www.properstar.com.br',
    'en-NZ': 'www.properstar.co.nz',
    'en-GB': 'www.properstar.co.uk',
    cs: 'www.properstar.cz',
    'de-DE': 'www.properstar.de',
    da: 'www.properstar.dk',
    'es-ES': 'www.properstar.es',
    'fr-FR': 'www.properstar.fr',
    el: 'www.properstar.gr',
    'en-HK': 'www.properstar.hk',
    'en-IN': 'www.properstar.in',
    it: 'www.properstar.it',
    ja: 'www.properstar.jp',
    'de-LI': 'www.properstar.li',
    'fr-LU': 'www.properstar.lu',
    'de-LU': 'www.properstar.lu',
    'en-MU': 'www.properstar.mu',
    'es-MX': 'www.properstar.mx',
    'en-PH': 'www.properstar.ph',
    pl: 'www.properstar.pl',
    'pt-PT': 'www.properstar.pt',
    'ar-QA': 'www.properstar.qa',
    ro: 'www.properstar.ro',
    ru: 'www.properstar.ru',
    sv: 'www.properstar.se',
    'en-SG': 'www.properstar.sg',
    zh: 'www.sodichan.com',
    'zh-Hans-HK': 'www.sodichan.com',
    'zh-Hans-MO': 'www.sodichan.com',
    tr: 'www.properstar.com.tr',
    'en-ZA': 'www.properstar.co.za',
    'it-IT': 'www.properstar.it',
    'hr-HR': 'www.properstar.com',
    'ru-RU': 'www.properstar.ru',
    'zh-CN': 'www.sodichan.com',
    'el-GR': 'www.properstar.gr',
    'sk-SK': 'www.properstar.com',
    'ro-RO': 'www.properstar.ro',
    'da-DK': 'www.properstar.dk',
    'ja-JP': 'www.properstar.jp',
    'pl-PL': 'www.properstar.pl',
    'tr-TR': 'www.properstar.com.tr',
    'cs-CZ': 'www.properstar.cz',
    'nl-NL': 'www.properstar.com',
    'sv-SE': 'www.properstar.se',
  },
}
